/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import { Skill, Skill$inboundSchema } from "./skill.js";
import { SkillVersion, SkillVersion$inboundSchema } from "./skillversion.js";

/**
 * The result of recording an uploaded skill manifest, including whether the operation created either resource.
 */
export type RecordSkillResult = {
  /**
   * Whether this request created the skill.
   */
  createdSkill: boolean;
  /**
   * Whether this request created a new immutable version rather than resolving to an existing canonical version.
   */
  createdVersion: boolean;
  /**
   * An active project skill. All API reads return active skills, and archive returns an empty response.
   */
  skill: Skill;
  /**
   * An immutable version of a skill manifest.
   */
  version: SkillVersion;
};

/** @internal */
export const RecordSkillResult$inboundSchema: z.ZodMiniType<
  RecordSkillResult,
  unknown
> = z.pipe(
  z.object({
    created_skill: z.boolean(),
    created_version: z.boolean(),
    skill: Skill$inboundSchema,
    version: SkillVersion$inboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      "created_skill": "createdSkill",
      "created_version": "createdVersion",
    });
  }),
);

export function recordSkillResultFromJSON(
  jsonString: string,
): SafeParseResult<RecordSkillResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => RecordSkillResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'RecordSkillResult' from JSON`,
  );
}
